import TherapistPerformance from './TherapistPerformance'
export default TherapistPerformance
